import { Button } from '@breetometer/components';
import { type IWalletAddress } from 'BreetHelpers';
import { useSavedWalletAddressApi } from 'BreetHooks';
import { openModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

import WalletAddressTable from './WalletAddress.Table';
import WalletAddressesEmpty from './WalletAddresses.Empty';
import type { IWalletAddressesManageProps } from './WalletAddresses.helpers';

const WalletAddressesManage = ({ onAddNewAddress, onEmptyWalletAddress }: IWalletAddressesManageProps) => {
	const { savedWalletAddresses, isSavedWalletAddressesEmpty } = useSavedWalletAddressApi();

	const dispatch = useAppDispatch();

	const handleDeleteAddress = useCallback(
		(item: IWalletAddress) => () => {
			dispatch(
				openModal({
					id: 'deleteWalletAddress',
					metadata: { id: item._id, address: item.address, label: item.label },
					hideCloseButton: true,
				})
			);
		},
		[dispatch]
	);

	const handleEditAddress = useCallback(
		(item: IWalletAddress) => () => {
			dispatch(
				openModal({
					id: 'editWalletAddressName',
					metadata: { label: item.label, address: item.address, token: item.token, network: item.network },
				})
			);
		},
		[dispatch]
	);

	if (isSavedWalletAddressesEmpty) {
		onEmptyWalletAddress();
		return <WalletAddressesEmpty />;
	}

	return (
		<>
			<div className='savedwalletaddress manage bg-primary-500 border-dark-navy'>
				<WalletAddressTable
					data={savedWalletAddresses}
					onEdit={handleEditAddress}
					onDelete={handleDeleteAddress}
					mode='manage'
				/>
			</div>

			{savedWalletAddresses.length < 3 && (
				<div className='savedwalletaddress-cta'>
					<Button
						label='Add New Address'
						variant='tertiary'
						type='button'
						onClick={onAddNewAddress}
					/>
				</div>
			)}
		</>
	);
};

export default WalletAddressesManage;
